import { StateObj } from 'src/types'

export const hamidashiOfMiddleFingerBeltBackStyle = (ctx: CanvasRenderingContext2D, hamidashi: StateObj): void => {
  if (hamidashi?.value === 'none') return
  ctx.lineWidth = 0.8
  ctx.strokeStyle = '#282828'
  ctx.fillStyle = hamidashi.color

  // 中指袋
  ctx.beginPath()
  ctx.moveTo(274, 118) // 左上
  ctx.quadraticCurveTo(233, 280, 285, 444) // 左下
  ctx.quadraticCurveTo(289, 444, 289, 444) // 右下
  ctx.quadraticCurveTo(238, 280, 278, 117) // 右上
  ctx.quadraticCurveTo(272, 118, 272, 118) // 左上
  ctx.fill()
  ctx.stroke()
  ctx.closePath()

  // 小指・薬指袋
  ctx.beginPath()
  ctx.moveTo(196, 177) // 左上
  ctx.quadraticCurveTo(157, 310, 237, 529) //
  ctx.quadraticCurveTo(244, 572, 253, 615) // 左下
  ctx.quadraticCurveTo(257, 616, 257, 616) // 右下
  ctx.quadraticCurveTo(248, 577, 241, 529) //
  ctx.quadraticCurveTo(162, 308, 200, 177) //
  ctx.quadraticCurveTo(196, 177, 196, 177) //
  ctx.fill()
  ctx.stroke()
  ctx.closePath()
}
